const UpLeftArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.6569 17.6568L6.34315 6.34307M6.34315 6.34307V14.8283M6.34315 6.34307H14.8284"
        stroke="#215A8E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default UpLeftArrow;
